import React from 'react';

const SuccessCheckMarkIcon = () => {
  return (
    <svg width="108" height="108" viewBox="0 0 108 108" fill="none">
      <path
        d="M54.002 0C83.8014 0 107.996 24.1948 107.996 53.9942C107.996 83.7936 83.8014 107.988 54.002 107.988C24.2026 107.988 0.0078125 83.7936 0.0078125 53.9942C0.0078125 24.1948 24.2026 0 54.002 0Z"
        fill="#4CE532"
      />
      <path
        d="M53.9695 5.10645C80.9505 5.10645 102.857 27.0129 102.857 53.9939C102.857 80.9749 80.9505 102.881 53.9695 102.881C26.9885 102.881 5.08203 80.9749 5.08203 53.9939C5.08203 27.0129 26.9885 5.10645 53.9695 5.10645Z"
        fill="#65EE3F"
      />
      <path
        d="M31.8906 55.7877L45.1075 68.7042L76.0471 37.7646"
        stroke="white"
        strokeWidth="5.40692"
      />
    </svg>
  );
};

export default SuccessCheckMarkIcon;
